import { string, object } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { validateObjectId } from '@shared/utils';

export const vipTaskItemValidationSchema = object().shape({
  documentId: string()
    .test({
      message: YUP_ERRORS_MESSAGES.OBJECT_ID,
      test: validateObjectId,
    })
    .required(YUP_ERRORS_MESSAGES.FILE),
});
